export const removeEncryptedCode = (memo: string) => {
  const result = memo.split("==")[1].trim();
  return result;
};
